module.exports = __webpack_public_path__ + "static/what-is-merged-mining-8a5762c7aee2ea0da88f6136932f7190.svg";